import React, { Component } from 'react';
import './DashboardView.scss';
import { ApolloProvider, Query } from 'react-apollo';

import gql from 'graphql-tag';
import {
    PrimaryButton, CommandBarButton,
} from 'office-ui-fabric-react/lib/Button';
import { FontSizes, ComboBox } from 'office-ui-fabric-react/lib';
import { TooltipHost, TooltipDelay } from 'office-ui-fabric-react/lib/Tooltip';
import { Stack, Spinner, Toggle, IconButton, Icon, ContextualMenu } from 'office-ui-fabric-react';
import { Mutation } from '@apollo/react-components';
import DNDBoard from './DNDBoard';
import ReportConfiguration from '../ReportView/ReportConfiguration/ReportConfiguration';
import DashboardConfiguration from '../ReportView/ReportConfiguration/DashboardConfiguration';
import Utils from '../common/Utils';
import { MyContext } from '../../context';
import { setPinnedDashboard, queryGetDashboards } from "../../queries/queryReport";
import AIDisclaimer from '../common/AIDisclaimer';



const screenSizeWidth = window.innerWidth;
export default class ReportView extends Component {
    constructor(props) {
        super(props);
        this.reportConf = React.createRef();
        this.dashboardConf = React.createRef();
        this.dashboardConfChange = React.createRef();
        this.state = {
            helpPanel: false,
            editMode: false,
            query: 0,
            isEdit: false,
            dashboardItem: {
                key: this.props?.userRules?.pinnedDashboard ?? "Default",
                text: "",
                users: "",
                user: "",
                isOwner: true,
                managers: "",
                isManager: false,
                hasEntryListAccess: false,
                hasEntryListDownload: false
            },
            type: "",
            pinned: {
                state: false,
                dashboardId: ""
            },
            dashboards: [],
            refetchDashboards: false,
            loadingDashboards: true,
            showDashboardMenu: false,
            dashboardMenuTarget: null,
            useAdminUserTemplate: false,
            useStandardUserTemplate: false
        };
        this.data = null;
    }

    componentDidMount() {
        this.queryDashboardsList(this.props.authorization, this.props.apol, "");
    }

    async componentDidUpdate() {

        if (this.state.refetchDashboards || this.state.refetchDashboards === null) {
            this.queryDashboardsList(this.props.authorization, this.props.apol, "");
        }

    }


    onNewReport = (ev) => {
        if (this.reportConf.current) {
            this.reportConf.current.state.isNew = true;
            this.reportConf.current.showPanel();
        }
    }

    onNewReportModal = (ev) => {
        if (this.reportConf.current) {
            this.reportConf.current.state.isNew = true;
            this.reportConf.current.showModal();
        }
    }

    onNewDashboard = (ev) => {
        if (this.dashboardConf.current) {
            this.dashboardConf.current.state.isNew = true;
            this.dashboardConf.current.showPanel();
        }
    }

    onNewDashboardModal = (ev) => {
        if (this.dashboardConf.current) {
            this.dashboardConf.current.state.isNew = true;
            this.dashboardConf.current.showModal();
        }
    }

    onChangeDashboardModal = (ev) => {
        if (this.dashboardConfChange.current) {

            let managers = this.state.dashboardItem.managers == "" ? [] : this.state.dashboardItem.managers.split(',').map(u => { return { userId: u } })
            let owners = this.state.dashboardItem.user == "" ? [] : this.state.dashboardItem.user.split(',').map(u => { return { userId: u } })
            let users = this.state.dashboardItem.users == "" ? [] : this.state.dashboardItem.users.split(',').map(u => { return { userId: u } })

            this.dashboardConfChange.current.state.changedTitle = this.state.dashboardItem.text; //title
            this.dashboardConfChange.current.state.dashboardUsers = users; //viewers
            this.dashboardConfChange.current.state.managers = managers; //managers
            this.dashboardConfChange.current.state.owner = owners; //owners

            this.dashboardConfChange.current.showModal();
        }
    }

    changeMode = () => {
        this.setState({ editMode: !this.state.editMode });
    }

    pinDashboard = async () => {
        var data = await this.props.apol
            .mutate({
                mutation: setPinnedDashboard,

                variables: {
                    dashboardId: this.state.dashboardItem.key,
                }
            });
        if (data.data.setPinnedDashboard) {
            this.setState({ pinned: { state: true, dashboardId: this.state.dashboardItem.key } });
        } else {
            this.setState({ pinned: { state: false, dashboardId: null } });
        }
    }

    handleDashboardMenuClick = (templateType) => {
        let useStandardUserTemplate = false;
        let useAdminUserTemplate = false;
        if (templateType === 'user') {
            useStandardUserTemplate = true;
        } else if (templateType === 'admin') {
            useAdminUserTemplate = true;
        }
        // Store the selected template props in state
        this.setState({ useStandardUserTemplate: useStandardUserTemplate, useAdminUserTemplate: useAdminUserTemplate, showDashboardMenu: false }, () => {
            if (this.dashboardConf.current) {
                this.dashboardConf.current.state.isNew = true;
                this.dashboardConf.current.showModal();
            }
        });
    };
    onCreateDashboardMenu = (ev) => {
        this.setState({ showDashboardMenu: true, dashboardMenuTarget: ev.currentTarget });
    };


    render() {
        // toast.success(""+this.props.user)
        return (
            <div className="Out">
                <ApolloProvider client={this.props.apol}>
                    {this.queryDashboard(this.props.authorization, this.props.apol, this.state.dashboardItem.key)}
                </ApolloProvider>
            </div>
        );
    }

    renderHeader = (reload) => (<MyContext.Consumer>
        {(context) => (
            <header className={window.location.pathname.includes("main") ? "dashboard-header-main" : "dashboard-header"}>
                <ReportConfiguration
                    reloadFunc={reload}
                    ref={this.reportConf}
                    id={Utils.guidGenerator()}
                    title=""
                    text=""
                    icon=""
                    type=""
                    cycle="Today"
                    keywords=""
                    startDate=""
                    endDate=""
                    sortOrder={0}
                    dashboardId={this.state.dashboardItem.key}
                    isManager={this.state.dashboardItem.isManager}
                    isOwner={this.state.dashboardItem.isOwner}
                    kpi=""
                    tForm="cycle"
                    isNew
                    authorization={this.props.authorization}
                    apol={this.props.apol}
                    userRules={this.props.userRules}
                    theme={this.props.theme}
                    conversationType=""
                    problemTypes=""
                    pstnNumber=""
                    dtmfEndDate=""
                />


                <Stack horizontal>
                    {this.props.userRules.ruleAccess.userReporting != "No" && <TooltipHost
                        content={context.getTranslation("dashboard", "createNewReport")}
                        hidden={Utils.lsGet('helpMode') === 'false'}
                        calloutProps={{ gapSpace: 0 }}
                        delay={TooltipDelay.long}
                    >
                        <CommandBarButton
                            iconProps={{ iconName: 'Add' }}
                            text={context.getTranslation("dashboard", "createReport")}
                            style={{ padding: '7px', cursor: 'pointer', fontSize: FontSizes.Icon }}
                            onClick={this.onNewReportModal}
                            disabled={!(this.state.dashboardItem.isOwner || this.state.dashboardItem.isManager)}
                        />
                    </TooltipHost>}

                    {this.getAvailableDashboards()}

                    <Stack.Item grow={3}><div /></Stack.Item>
                    <Stack horizontal>
                        <Stack.Item styles={{ root: { paddingRight: 10 } }}>
                            {this.renderSaveButton()}
                        </Stack.Item>
                        <Stack.Item>
                            <Toggle
                                label={context.getTranslation("dashboard", "editMode")}
                                checked={this.state.editMode}
                                disabled={!(this.state.dashboardItem.isOwner || this.state.dashboardItem.isManager)}
                                onChange={(event, val) => {
                                    this.setState({ editMode: val, isEdit: val });
                                }}
                                onText={context.getTranslation("dashboard", "on")}
                                offText={context.getTranslation("dashboard", "off")}
                            />
                        </Stack.Item>
                    </Stack>
                </Stack>
            </header>
        )
        }
    </MyContext.Consumer>
    )

    renderSaveButton = () => (
        <MyContext.Consumer>
            {(context) => (
                this.state.isEdit ? (
                    <Mutation
                        mutation={gql` 
       mutation mut($input:[ReportPositionInput]){
        updateReportTable(input:$input)     
      }`}
                    >
                        {
                            (run) => (
                                <PrimaryButton
                                    text={context.getTranslation("common", "save")}
                                    onClick={
                                        () => {
                                            this.setState({ isEdit: false, editMode: false });
                                            run({ variables: { input: this.state.layout } });
                                        }
                                    }
                                />
                            )
                        }
                    </Mutation>

                ) : <></>)
            }
        </MyContext.Consumer>)

    queryDashboard = (input, apol, dashboardId) => (

        <Query
            key={`query:${this.state.query}`}
            query={gql`
        query ent ($input : AuthInput, $dashboardId: String!) {
          getReports (input: $input, dashboardId: $dashboardId)
          {
            id
            integrationId
            title
            widget
            text
            type
            kpi
            tenantId
            botAppId
            jobId
            valueType
            startDate
            endDate
            conversationType
            problemTypes
            pstnNumber
            dtmfStartDate
            dtmfEndDate
            position {
                w
                h
                x
                y
            }
            cycle
            keywords
            tForm
            categories
            alarming {
                mail
                eventType
                value
                alarmActive
            }
            reportSend
            reportMail
            emailAttachmentFormat
            jobType
            {
                intervalMonth
                intervalDay
                intervalHour
                intervalMinute
                intervalType
                jobStartTime
            }
            persons {
              userId
              name
              id
              members
            }

          }
        }

    `}
            variables={{ input, dashboardId }}
            onCompleted={(data) => {
                this.data = data;
            }
            }
        >
            {({
                loading, error, data, refetch,
            }) => {
                if (loading) return <MyContext.Consumer>{(context) => (<Spinner label={context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />)}</MyContext.Consumer>;
                if (error) return <h1> </h1>;
                if (data.getReports != null && data.getReports.length > 0) {
                    let reports = data.getReports;
                    if (!(this.props.userRules.addOnQualityManagement && this.props.userRules.ruleAccess.complianceQMResultsAccess)) {
                        reports = reports.filter(r => r.kpi !== "QMAgentCompared");
                    }
                    return (
                        <div id={`mainWindow${reports.length}`}>
                            {this.renderHeader(() => {
                                refetch();
                                this.setState({ query: this.state.query });
                            })}
                            <div style={{ marginBottom: '150px' }} className={window.location.pathname.includes("main") ? "dashboard-wrapper-main" : "dashboard-wrapper"}>
                                <DNDBoard
                                    id={`board${reports.id}`}
                                    setLayout={this.setLayout}
                                    reloadFunc={() => {
                                        refetch();
                                    }}
                                    data={reports}
                                    input={input}
                                    apol={apol}
                                    isDraggable={this.state.editMode}
                                    userRules={this.props.userRules}
                                    authorization={this.props.authorization}
                                    theme={this.props.theme}
                                    isManager={this.state.dashboardItem.isManager}
                                    isOwner={this.state.dashboardItem.isOwner}
                                    hasEntryListAccess={this.state.dashboardItem.hasEntryListAccess}
                                    hasEntryListDownload={this.state.dashboardItem.hasEntryListDownload}
                                />
                            </div>
                            <div style={{ position: 'fixed', bottom: 0 }}>
                                <AIDisclaimer theme={this.props.theme} withBackground={true} />
                            </div>
                        </div>
                    );
                }
                return (<MyContext.Consumer>
                    {(context) => (
                        <div>
                            {this.renderHeader(refetch)}
                            <div className="dashboard-wrapper">
                                <h3>{context.getTranslation("dashboard", "noWidgets")}</h3>
                            </div>
                        </div>)
                    }
                </MyContext.Consumer>
                );
            }}
        </Query>
    );

    async queryDashboardsList(input, apol, type) {

        try {
            const { data } = await apol.query({
                query: queryGetDashboards,
                variables: { input, type },
                fetchPolicy: 'network-only' // This ensures that the query fetches the latest data from the server
            });
            if (data) {
                const dashboards = data.getDashboards.map(dashboard => ({
                    text: dashboard.title,
                    key: dashboard.id,
                    users: dashboard.users,
                    user: dashboard.user,
                    isOwner: dashboard.isOwner,
                    managers: dashboard.managers,
                    isManager: dashboard.isManager,
                    hasEntryListAccess: dashboard.hasEntryListAccess,
                    hasEntryListDownload: dashboard.hasEntryListDownload,
                }));

                const pinnedDashboard = dashboards.find(dashboard => this.props.userRules.pinnedDashboard === dashboard.key) || { key: "Default", text: "Dashboard User", users: "", user: this.props.userRules.userId, isOwner: true, isManager: false, managers: "", hasEntryListAccess: false, hasEntryListDownload: false };
                const currentDashboard = dashboards.find(dashboard => this.state.dashboardItem.key === dashboard.key);


                this.setState({
                    dashboards: [{ key: "Default", text: "Dashboard User", users: "", user: this.props.userRules.userId, isOwner: true, isManager: false, managers: "", hasEntryListAccess: false, hasEntryListDownload: false }, ...dashboards],
                    dashboardItem: this.state.refetchDashboards ? (currentDashboard || this.state.dashboardItem) : pinnedDashboard,
                    refetchDashboards: false,
                    loadingDashboards: false
                });
            }

        } catch (error) {
            console.log(error);
        }

    }

    refreshDashboard = (value) => {
        this.setState({ refetchDashboards: value });
    };
    getAvailableDashboards = () => {

        return (<MyContext.Consumer>{(context) => (
            <Stack horizontal>
                {!this.state.loadingDashboards && (

                    <>
                        <DashboardConfiguration
                            reloadFuncDashboard={this.refreshDashboard}
                            id={Utils.guidGenerator()}
                            title=""
                            text=""
                            type=""
                            user={this.props.userRules.userId}
                            isOwner={true}
                            hasEntryListAccess={false}
                            hasEntryListDownload={false}
                            isNew
                            authorization={this.props.authorization}
                            apol={this.props.apol}
                            ref={this.dashboardConf}
                            userRules={this.props.userRules}
                            theme={this.props.theme}
                            useStandardUserTemplate={this.state.useStandardUserTemplate}
                            useAdminUserTemplate={this.state.useAdminUserTemplate}


                        />
                        <DashboardConfiguration
                            id={this.state.dashboardItem.key}
                            title={this.state.dashboardItem.text}
                            text=""
                            type=""
                            users={this.state.dashboardItem.users}
                            user={this.state.dashboardItem.user}
                            managers={this.state.dashboardItem.managers}
                            isOwner={this.state.dashboardItem.isOwner}
                            isManager={this.state.dashboardItem.isManager}
                            hasEntryListAccess={this.state.dashboardItem.hasEntryListAccess}
                            hasEntryListDownload={this.state.dashboardItem.hasEntryListDownload}
                            authorization={this.props.authorization}
                            apol={this.props.apol}
                            ref={this.dashboardConfChange}
                            userRules={this.props.userRules}
                            theme={this.props.theme}
                            reloadFuncDashboard={this.refreshDashboard}
                        />

                    </>
                )}
                {this.props.userRules.ruleAccess.userReporting != "No" && <>

                    {(((this.props?.userRules?.pinnedDashboard === this.state.dashboardItem.key) && !this.state.pinned.state) || (this.state.pinned.state && (this.state.pinned.dashboardId === this.state.dashboardItem.key))) ? (
                        <TooltipHost
                            content={context.getTranslation("dashboard", "pinnedDashboard")}
                            hidden={Utils.lsGet('helpMode') === 'false'}
                            calloutProps={{ gapSpace: 0 }}
                            delay={TooltipDelay.long}
                        >

                            <CommandBarButton
                                iconProps={{ iconName: 'Pinned' }}
                                text={screenSizeWidth < 600 ? "" : context.getTranslation("dashboard", "pinnedDashboard")}
                                style={{ padding: '7px', cursor: 'pointer', fontSize: FontSizes.Icon }}
                                disabled={true}
                            />

                        </TooltipHost>
                    ) : (
                        <TooltipHost
                            content={context.getTranslation("dashboard", "pinDashboard")}
                            hidden={Utils.lsGet('helpMode') === 'false'}
                            calloutProps={{ gapSpace: 0 }}
                            delay={TooltipDelay.long}
                        >

                            <CommandBarButton
                                iconProps={{ iconName: 'Pin' }}
                                text={screenSizeWidth < 600 ? "" : context.getTranslation("dashboard", "pinDashboard")}
                                style={{ padding: '7px', cursor: 'pointer', fontSize: FontSizes.Icon }}
                                onClick={this.pinDashboard}
                            />
                        </TooltipHost>
                    )}


                    <ComboBox
                        selectedKey={this.state.dashboardItem.key}
                        allowFreeform={false}
                        onChange={this.onChange}
                        options={this.state.dashboards}
                    />
                    <TooltipHost
                        content={context.getTranslation("dashboard", "createDashboard")}
                        hidden={Utils.lsGet('helpMode') === 'false'}
                        calloutProps={{ gapSpace: 0 }}
                        delay={TooltipDelay.long}
                    >
                        <CommandBarButton
                            iconProps={{ iconName: 'Add' }}
                            text={screenSizeWidth < 600 ? "" : context.getTranslation("dashboard", "createDashboard")}
                            style={{ padding: '7px', cursor: 'pointer', fontSize: FontSizes.Icon }}
                            onClick={this.onCreateDashboardMenu}
                        />
                        {this.state.showDashboardMenu && (
                            <ContextualMenu
                                items={[
                                    {
                                        key: 'new',
                                        text: context.getTranslation("dashboard", "newDashboard"),
                                        onClick: () => this.handleDashboardMenuClick('new'),
                                    },
                                    {
                                        key: 'user',
                                        text: context.getTranslation("dashboard", "userTemplate"),
                                        onClick: () => this.handleDashboardMenuClick('user'),
                                    },
                                    ...((this.props.userRules.access === "SuperUser" || this.props.userRules.access === "Administrator")
                                        ? [{
                                            key: 'admin',
                                            text: context.getTranslation("dashboard", "adminTemplate"),
                                            onClick: () => this.handleDashboardMenuClick('admin'),
                                        }]
                                        : [])
                                ]}
                                target={this.state.dashboardMenuTarget}
                                onDismiss={() => this.setState({ showDashboardMenu: false })}
                            />
                        )}
                    </TooltipHost>
                    <TooltipHost
                        content={context.getTranslation("dashboard", "changeDashboard")}
                        hidden={Utils.lsGet('helpMode') === 'false'}
                        calloutProps={{ gapSpace: 0 }}
                        delay={TooltipDelay.long}
                    >


                        <CommandBarButton
                            iconProps={{ iconName: 'Edit' }}
                            style={{ padding: '7px', cursor: 'pointer', fontSize: FontSizes.Icon }}
                            onClick={this.onChangeDashboardModal}
                            text={screenSizeWidth < 600 ? "" : context.getTranslation("dashboard", "changeDashboard")}
                            disabled={!(this.state.dashboardItem.key) || this.state.dashboardItem.key === "Default"}
                        />


                    </TooltipHost>
                </>}
            </Stack>
        )}</MyContext.Consumer>
        );
    };

    onChange = (event, option, index, value) => {
        this.setState({ dashboardItem: option });
    };

    setLayout = (layout) => {
        let out = [];
        for (let item = 0; item < layout.length; item++) {
            const id = layout[item].i.split(":")[0]
            out.push({
                i: id,
                x: layout[item].x,
                y: layout[item].y,
                w: layout[item].w,
                h: layout[item].h,
            });
        };
        this.setState({ layout: out });
    }
}
